function notifyGoogleMapsReady() {
  window.dispatchEvent(new Event('google-maps-ready'))
}

function waitForGooglePlaces(attempt = 0) {
  if (typeof google !== 'undefined' && google.maps?.places?.Autocomplete) {
    notifyGoogleMapsReady()
    return
  }

  if (attempt < 80) {
    window.setTimeout(() => waitForGooglePlaces(attempt + 1), 50)
  }
}

export function loadGoogleMapsPlacesApi() {
  const mapsKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY

  if (!mapsKey) {
    return
  }

  const existingScript = document.getElementById('google-maps-script') as HTMLScriptElement | null

  if (existingScript) {
    waitForGooglePlaces()
    return
  }

  const script = document.createElement('script')
  script.id = 'google-maps-script'
  script.src = `https://maps.googleapis.com/maps/api/js?key=${mapsKey}&libraries=places&loading=async`
  script.async = true
  script.defer = true
  script.onload = () => {
    waitForGooglePlaces()
  }

  document.head.appendChild(script)
}
